import { useState, useEffect } from 'react';
import { Outlet, redirect, useSearchParams, useNavigate } from 'react-router-dom';

import liff from '@line/liff';
import { useAtom } from 'jotai';

import LineStaffHeader from './LineStaffHeader';

import { attachLineUser } from '@/api/attachLineUser';
import { checkInviteToken } from '@/api/checkInviteToken';
import { getLineUserRole } from '@/api/getLineUserRole';
import { LineUserAtom } from '@/jotai/jotai';

const LineStaffLayout: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [lineUser, setLineUser] = useAtom(LineUserAtom);
  /* eslint @typescript-eslint/no-explicit-any: 0 */
  const [isValid, setIsValid] = useState(false);
  const [isAttached, setIsAttached] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    liff
      .init({ liffId: import.meta.env.VITE_LIFF_ID, withLoginOnExternalBrowser: true })
      .then(() => {
        if (liff.isLoggedIn()) {
          setLineUser({
            lineID: liff.getContext()?.userId ?? '',
            accessToken: liff.getAccessToken() ?? '',
          });
        }
      });
  }, []);

  useEffect(() => {
    if (token) {
      const checkToken = async (token: string) => {
        const result = await checkInviteToken(token);
        if (result.status === 200) {
          setIsValid(true);
        } else {
          alert('招待URLが無効です');
          redirect('/');
        }
        return result;
      };
      checkToken(token);
    }
  }, [token]);

  useEffect(() => {
    if (isValid) {
      const attach = async (token: string, line_id: string) => {
        const result = await attachLineUser(token, line_id);
        if (result.status === 200) {
          setIsAttached(true);
        }
        return result;
      };
      if (token && lineUser) {
        attach(token, lineUser.lineID)
          .then((result) => {
            if (result.status === 200) {
              setIsAttached(true);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }, [isValid]);

  useEffect(() => {
    if (isAttached) {
      alert('アカウントが紐づけられました');
      redirect('/');
    }
  }, [isAttached]);

  useEffect(() => {
    const fetchLineUserRole = async (lineAccessToken: string) => {
      try {
        const result = await getLineUserRole(lineAccessToken);
        if (result.status === 200) {
          console.log('ユーザーのロール:', result.result.role);
          if (result.result.role !== 'staff') {
            alert('スタッフアカウントでログインしてください');
            navigate('/not-found');
          }
        }
      } catch (error) {
        console.error('ユーザーのロールの取得に失敗しました', error);
        navigate('/not-found');
      }
      if (lineUser) {
        fetchLineUserRole(lineUser.accessToken);
      }
    };
  }, [lineUser]);

  return (
    <div className="relative min-h-[100vh] pb-10">
      <LineStaffHeader />
      <Outlet />
    </div>
  );
};

export default LineStaffLayout;
